import { may, type CanHolder } from "../../lib/access";

/**
 * Export affordance (ADR-API-09: the server re-checks every request): the
 * `export` operation of the rights matrix ([F-027]), from `/me.can` for the
 * list or the incident's `can` for its PDF.
 */
export function canExport(subject: CanHolder | null | undefined): boolean {
  return may(subject, "export");
}
